import React from "react";
import {
    Box,
    Typography,
    Button,
    Paper,
    Chip,
} from "@mui/material";

// Components
import Icon from "@/theme/vectors/bundle";
import ProductAttributes from "./ProductAttributes";
import ProductVariants from "./ProductVariants";

const ProductConfigTab = ({ 
    product,
    onOpenAttributesPanel,
    onEditAttribute,
    onRemoveAttribute,
    onPriceCellClick,
    onPriceChange,
    onPriceUpdate,
    onPriceKeyPress,
    onPrediscountPriceCellClick,
    onPrediscountPriceChange,
    onPrediscountPriceUpdate,
    onPrediscountPriceKeyPress,
    onActiveChange,
    onLockChange,
    onMediaOrderChange,
    onRemoveMediaFromVariant,
    onSetMainMedia,
    tempPriceValue,
    editingPriceVariantId,
    tempPrediscountPriceValue,
    editingPrediscountPriceVariantId,
    setActiveVariantId,
    openMediaPanel,
    updateVariantMediaOrder,
    isAttributesSaved = true,
    t
}) => {
    return (
        <Box component="form" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* Product Attributes Section */}
            <ProductAttributes 
                attributes={product.attributes}
                onOpenAttributesPanel={onOpenAttributesPanel}
                onEditAttribute={(index) => {
                    if (!isAttributesSaved) {
                        onEditAttribute(index);
                        onOpenAttributesPanel();
                    } else {
                        onOpenAttributesPanel();
                    }
                }}
                onRemoveAttribute={onRemoveAttribute}
                isAttributesSaved={isAttributesSaved}
                t={t}
            />
            
            {/* Product Variants Table */}
            <Box sx={{ mt: 2 }}>
                <Typography variant="h6" gutterBottom sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                        {t('product.detail.productVariants')}
                        {product.variants && product.variants.length > 0 && (
                            <Chip 
                                size="small" 
                                label={product.variants.length} 
                                sx={{ ml: 1, height: 20, fontSize: '0.75rem' }}
                            />
                        )}
                    </Box>
                </Typography>
                {product.variants && product.variants.length > 0 ? (
                    <ProductVariants 
                        variants={product.variants}
                        medias={product.medias}
                        onPriceCellClick={onPriceCellClick}
                        onPriceChange={onPriceChange}
                        onPriceUpdate={onPriceUpdate}
                        onPriceKeyPress={onPriceKeyPress}
                        onPrediscountPriceCellClick={onPrediscountPriceCellClick}
                        onPrediscountPriceChange={onPrediscountPriceChange}
                        onPrediscountPriceUpdate={onPrediscountPriceUpdate}
                        onPrediscountPriceKeyPress={onPrediscountPriceKeyPress}
                        onActiveChange={onActiveChange}
                        onLockChange={onLockChange}
                        onMediaOrderChange={onMediaOrderChange}
                        onRemoveMediaFromVariant={onRemoveMediaFromVariant}
                        onSetMainMedia={onSetMainMedia}
                        tempPriceValue={tempPriceValue}
                        editingPriceVariantId={editingPriceVariantId}
                        tempPrediscountPriceValue={tempPrediscountPriceValue}
                        editingPrediscountPriceVariantId={editingPrediscountPriceVariantId}
                        setActiveVariantId={setActiveVariantId}
                        openMediaPanel={openMediaPanel}
                        updateVariantMediaOrder={updateVariantMediaOrder}
                        t={t}
                    />
                ) : (
                    <Paper sx={{ p: 3, textAlign: 'center' }}>
                        <Typography>
                            {t('product.detail.noVariants')}
                        </Typography>
                        <Button 
                            variant="outlined" 
                            sx={{ mt: 2 }}
                            startIcon={<Icon name="add" />}
                            onClick={onOpenAttributesPanel}
                        >
                            {t('common.add')} {t('product.detail.attributes')}
                        </Button>
                    </Paper>
                )}
            </Box>
        </Box>
    );
};

export default ProductConfigTab;